import {
  ProducedActivityAction,
  ProducedActivityState,
} from 'store/data/producedActivity';
import { domainUtility } from 'utility';

const initialState: ProducedActivityState = { allIds: [], byId: {} };

const producedActivityReducer = (
  state: ProducedActivityState = initialState,
  action: ProducedActivityAction,
): ProducedActivityState => {
  switch (action.type) {
    case 'data/producedActivity/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/producedActivity/SET':
      return domainUtility.set(state, action.payload);
    case 'data/producedActivity/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/producedActivity/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/producedActivity/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default producedActivityReducer;
